const baseUrl = import.meta.env.VITE_API_URL
const filesUrl = import.meta.env.VITE_FILES_URL
const manifestEndpoint = import.meta.env.VITE_MANIFEST_URL
const environment = import.meta.env.VITE_ENVIRONMENT
const gtag = import.meta.env.VITE_GTAG

export const MANIFEST_URL = filesUrl + manifestEndpoint
export const LEADERBOARD_BATCH_SIZE = import.meta.env.VITE_LB_BATCH_SIZE
export const LEADERBOARD_MAX_PAGE = 10
export const GAP_BETWEEN_ITEMS = 8
export const ITEM_HEIGHT = 68.39
export const OVERSCAN_ITEMS_COUNT = 5
export { filesUrl, environment, gtag, baseUrl }
